import { Order } from 'effect'
import { Temporal, toTemporalInstant } from 'temporal-polyfill'

export const DEFAULT_TIME_ZONE = 'Europe/Paris'

export const getLocalTimeZone = () => {
  return Temporal.Now.timeZoneId() ?? DEFAULT_TIME_ZONE
}

// Constructors

export const fromDateToTemporalInstant = (date: Date) =>
  toTemporalInstant.bind(date)()

export const fromIsoStringToTemporalInstant = (date: string) =>
  Temporal.Instant.from(date)

export const fromIsoStringToTemporalZonedDateTime = (
  date: string,
  timeZone?: string
) =>
  fromIsoStringToTemporalInstant(date).toZonedDateTimeISO(
    timeZone ?? getLocalTimeZone()
  )
export const fromDateToTemporalPlainDate = (date: Date) =>
  fromDateToTemporalInstant(date).toZonedDateTimeISO('UTC').toPlainDate()
export const fromDateToTemporalPlainTime = (date: Date, timeZone?: string) =>
  fromDateToTemporalInstant(date)
    .toZonedDateTimeISO(timeZone ?? getLocalTimeZone())
    .toPlainTime()

export const fromDateToTemporalZonedDateTime = (
  date: Date,
  timeZone?: string
) =>
  fromDateToTemporalInstant(date).toZonedDateTimeISO(
    timeZone ?? getLocalTimeZone()
  )

// Destructors
export const fromTemporalToDate = (
  temporal: Temporal.Instant | Temporal.ZonedDateTime
) => new Date(temporal.epochMilliseconds)

export const fromTemporalPlainDateTimeToZonedDateTime = (
  temporal: Temporal.PlainDateTime,
  timeZone?: string
) => temporal.toZonedDateTime(timeZone ?? getLocalTimeZone())

export const fromTemporalZonedDateTimeToRfcString = (
  temporal: Temporal.ZonedDateTime
) => temporal.withTimeZone('UTC').toInstant().toString()
export const fromTemporalToRfcString = (
  temporal: Temporal.PlainDate | Temporal.PlainDateTime
) => temporal.toZonedDateTime('UTC').toInstant().toString()

// Comparators
export const ordPlainDate = Order.make(
  (a: string | Temporal.PlainDate | Temporal.PlainDateLike, b) =>
    Temporal.PlainDate.compare(a, b)
)
export const ordPlainYearMonth = Order.make(
  (a: string | Temporal.PlainYearMonth, b) =>
    Temporal.PlainYearMonth.compare(a, b)
)
export const ordPlainDateTime = Order.make(
  (a: string | Temporal.PlainDateTime | Temporal.PlainDateTimeLike, b) =>
    Temporal.PlainDateTime.compare(a, b)
)

// Utilities
export const plainDateToday = () => Temporal.Now.plainDateISO('UTC')

export const plainDateTimeLocalToday = () =>
  Temporal.Now.plainDateTimeISO(getLocalTimeZone())
